import { ProductItem } from "../types/products";
import { Unit } from "../enums/unit";
import { toGraphQLBaseUnit } from "../../../Utils/toGraphQLBaseUnit";
import { EditProductItemFormData } from "../types/products";
/**
 * Resolves a typed Unit enum value from a raw unit/baseUnit string stored on
 * the product item (propagated from the parent product at create time).
 */
export function unitFromItemBase(item: ProductItem): Unit | undefined {
  const raw = (item as unknown as Record<string, unknown>).unit as
    string | undefined;
  const wire = toGraphQLBaseUnit(raw);
  if (!wire) return undefined;
  return (Object.values(Unit) as string[]).includes(wire)
    ? (wire as Unit)
    : undefined;
}

// ── Default values derived from item prop ─────────────────────────────────

export const buildDefaultValues = (
  src: ProductItem
): EditProductItemFormData => ({
  variationName: src.variationName?.trim() ?? "",
  lotNumber: src.lotNumber?.trim() ?? "",
  purchasePrice: src.purchasePrice != null ? src.purchasePrice : undefined,
  salesPrice:
    (src.salesPrice ?? src.price) != null
      ? (src.salesPrice ?? src.price)
      : undefined,
  minSalesPrice: src.minSalesPrice != null ? src.minSalesPrice : undefined,
  weight: src.weight != null ? src.weight : undefined,
  height: src.height != null ? src.height : undefined,
  width: src.width != null ? src.width : undefined,
  thickness: src.thickness != null ? src.thickness : undefined,
  color: src.color?.trim() ?? "",
  material: src.material?.trim() ?? "",
  packagingType: src.packagingType?.trim() ?? "",
  packSize: src.packSize?.trim() ?? ""
});
